import { compact, first, last } from 'lodash'

export const getPathsFromPathname = pathname => compact(pathname.split('/'))
export const getRootPath = pathname => first(getPathsFromPathname(pathname))
export const getIdFromPath = pathname => last(getPathsFromPathname(pathname))
